<!-- Generated template for the EventItemComponent component -->
<div>
  {{text}}
</div>
